import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const SequencesPage = lazy(() => import('./pages/SequencesPage'));
const SegmentationPage = lazy(() => import('./pages/SegmentationPage'));
const BehaviorTriggersPage = lazy(() => import('./pages/BehaviorTriggersPage'));
const AbTestingPage = lazy(() => import('./pages/AbTestingPage'));
const DeliverabilityPage = lazy(() => import('./pages/DeliverabilityPage'));
const EmailCompliancePage = lazy(() => import('./pages/EmailCompliancePage'));

export const EmailAdvancedRoutes: RouteObject = {
  path: 'email-advanced',
  element: <ModuleGuard moduleId="marketing.email-advanced" />,
  handle: { crumb: 'Advanced Email Marketing' },
  children: [
    { index: true, element: <Navigate to="sequences" replace /> },
    { path: 'sequences', element: <SequencesPage />, handle: { crumb: 'Sequences' } },
    { path: 'segmentation', element: <SegmentationPage />, handle: { crumb: 'Segmentation' } },
    { path: 'behavior-triggers', element: <BehaviorTriggersPage />, handle: { crumb: 'Behavior Triggers' } },
    { path: 'ab-testing', element: <AbTestingPage />, handle: { crumb: 'A/B Testing' } },
    { path: 'deliverability', element: <DeliverabilityPage />, handle: { crumb: 'Deliverability' } },
    { path: 'email-compliance', element: <EmailCompliancePage />, handle: { crumb: 'Email Compliance' } },
  ],
};
